module.exports = __webpack_public_path__ + "static/augusta-intro.470b.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/augusta-intro.mp4
// module id = 231
// module chunks = 35783957827783 275574534170046